import React, { useEffect, useState } from "react";
import * as classes from './toast.module.css';

// Utility to set and get cookies
const setCookie = (name, value) => {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
};

const getCookie = (name) => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="))
    ?.split("=")[1];
};

const Toast = ({
  title,
  body,
  accentColour,
  duration,
  onClose,
  storageKey = "whatsNewDismissed",
}) => {
  const [visible, setVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const dismissed = getCookie(storageKey);
    if (!dismissed) {
      setVisible(true);
      if (duration) {
        const timer = setTimeout(() => {
          handleClose();
        }, duration);
        return () => clearTimeout(timer);
      }
    }
  }, [duration, onClose, storageKey]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, 300); // match slide-out duration
  };

  const dismissPermanently = () => {
    setCookie(storageKey, "true");
    handleClose();
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-4 right-4 z-50 w-[25rem] card bg-white ${classes.toastAnimate} ${isClosing ? classes.toastSlideOut : ''}`}
      style={{
        boxShadow: "5px 5px 4px #55555550",
        transform: "translateZ(0)",
        borderRadius: "0.7rem",
        overflow: "hidden",
      }}
    >
      <div
        className="upper flex justify-between items-center py-2 px-4 bg-[#272333] w-full"
        // style={{ backgroundColor: accentColour, width: "100%" }}
      >
        <span className="font-semibold text-white">{title}</span>
        {!duration && (
          <button
            className="flex items-center"
            onClick={handleClose}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                fill="white"
              />
            </svg>
          </button>
        )}
      </div>
      <div
        className="lower text-sm py-3 px-4 flex flex-col gap-3"
        style={{ color: '#393939' }}
      >
        <p>{body}</p>
        <button
          onClick={dismissPermanently}
          className="bg-[#0A9D03] text-white text-sm font-medium px-6 py-1.5 rounded-full hover:bg-green-700 transition"
        >
          Don’t show this again
        </button>
      </div>
    </div>
  );
};

export default Toast;
